import React, { useEffect, useState } from 'react';
import OwlCarousel from 'react-owl-carousel';
import AppPromo from '../restaurent/appPromo/AppPromo';
import CarRentalBanner from './CarRentalBanner';
import brand1 from "../../../../src/demo/brand1.png";
import brand2 from "../../../../src/demo/brand2.png";
import brand5 from "../../../../src/demo/brand5.png";
import brand6 from "../../../../src/demo/brand6.png";
import multipleCars from "../../../../src/demo/multipleCars.png";
import { apiData } from '../../../actions';
import { Car_Rentals } from '../../../Redux/Action/Action';
import { useDispatch, useSelector } from 'react-redux';
import SpcificPageModal from '../../Modals/SpcificPageModal';
import DataLoader from '../../../Utils/DataLoader';


const CarRental = () => {
	// const { active, setActive } = UsePlaceAuth();
	const [CoolDeals, setCoolDeals] = useState([]);
	const [loader, setLoader] = useState(false);
	const place = useSelector(state => state.place);
	const dispatch = useDispatch();

	const CoolFlightDeals = async () => {
		setLoader(true);
		let apiRes = await apiData.coolFlightDeals();
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setCoolDeals(
				apiRes?.data?.data
			);
			setLoader(false);
		}
		if (apiRes?.status >= 400 && apiRes?.status <= 500) {
			console.log("error");
			setLoader(false);
		}
	};

	const settings1 = {
		items: 4,
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
		nav: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1024: {
				items: 4
			}
		}
	};

	useEffect(() => {
		CoolFlightDeals();
		dispatch(Car_Rentals());
	}, []);

	const [specificModal, setSpecificModal] = useState(false);
	useEffect(() => {
		const hasSeenPopup = localStorage.getItem("hasSeenSpecficPopup");

		if (!hasSeenPopup) {
			setSpecificModal(true);
			localStorage.setItem("hasSeenSpecficPopup", "true");
		}

		if (place && !hasSeenPopup) {
			setSpecificModal(true);
		}

		// Save a timestamp when the user navigates away
		const handleVisibilityChange = () => {
			if (document.visibilityState === "hidden") {
				localStorage.setItem("lastSeen", Date.now());
			}
		};

		document.addEventListener("visibilitychange", handleVisibilityChange);

		// Cleanup the event listener on component unmount
		return () => {
			document.removeEventListener("visibilitychange", handleVisibilityChange);
		};
	}, [place]);

	const getUserEmail = () => {
		try {
			const rawUser = localStorage.getItem('userEmail');
			const user = JSON.parse(rawUser);
			return user?.email || '';
		} catch (error) {
			// Handle plain string fallback
			// console.error('Failed to parse userEmail from localStorage:', error);
			const rawUser = localStorage.getItem('userEmail');
			if (rawUser && typeof rawUser === 'string' && rawUser.includes('@')) {
				return rawUser;
			}
			return '';
		}
	};

	// Usage
	const userEmail = getUserEmail();

	const handleClicks = () => {
		handleSubmit();
	};
	const [formData, setFormData] = useState({
		email: '',
		city: '',
		travelerType: '',
	});

	const handleSubmit = async () => {
		const email = userEmail
		if (!email) {
			console.log('Please log in to continue.');
			return;
		}
		const { city, travelerType } = formData;


		const finalCity = place || city;
		// Construct the URL dynamically
		const url = `https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(email.split('@')[0])}&city=${encodeURIComponent(finalCity)}&travelerType=${encodeURIComponent(travelerType)}`;

		try {
			const response = await fetch(url, {
				method: 'GET',
			});

			if (response.ok) {
				const data = await response.json();
				console.log(data.message);
			} else {
				const error = await response.json();
				console.log(error.message || 'Submission failed');
			}
		} catch (error) {
			console.log(error.message || 'Failed to submit form');
		}
	};


	return (
		<div>
			<div className="banner-section rest-sec car-banner">
				<CarRentalBanner />
			</div>
			<div className="adver-sec car-rental">
				<div className="container">
					<div className="row">
						<div className="col-12 col-sm-12 col-md-12 col-lg-12">
							<a href="https://www.dpbolvw.net/click-8265264-15514929" target="_top">
								<img loading="lazy" src="https://www.lduhtrp.net/image-8265264-15514929" width="728" height="90" alt="Advertise" border="0" />
							</a>
						</div>
					</div>
				</div>
			</div>
			<div className="offer-section  car-rental-content">
				<div className="container">
					<div className="row">
						<div className="slider-sec">
							<div className="col-12 col-lg-12">
								<div className="slider-main">
									{loader ? (
										<DataLoader/>
									) : (
										CoolDeals.length > 0 && <OwlCarousel {...settings1}>
											{CoolDeals && CoolDeals?.map((ele) => {
												return (
													<div data-aos="zoom-in-right" className="testimonial-block product">
														<a href={ele.url} target="_blank" rel="noreferrer" onClick={handleClicks}>
															<div className="discount-block">
																<img loading="lazy" src={ele.image_url} alt="cool flight deals" />
																<h3>{ele.title}</h3>
															</div>
														</a>
													</div>
												)
											})}
										</OwlCarousel>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="car-sec">
				<div className="container">
					<div className="row">
						<div className="col-12 col-md-12 col-lg-12">
							<h2>Rent With Companies You Know and Trust</h2>
							<ul>
								<li>
									<img loading="lazy" src={brand1} alt="Brand 1" />
								</li>
								<li>
									<img loading="lazy" src={brand2} alt="Brand 2" />
								</li>
								<li>
									<img loading="lazy" src={brand5} alt="Brand 5" />
								</li>
								<li>
									<img loading="lazy" src={brand6} alt="Brand 6" />
								</li>
							</ul>
							<img loading="lazy" src={multipleCars} alt="Cars" />
						</div>
					</div>
				</div>
			</div>
			<AppPromo />
			<>
				{specificModal && (
					<SpcificPageModal
						specificModal={specificModal}
						setSpecificModal={setSpecificModal}
					/>
				)}
			</>
		</div>
	)
}
export default CarRental